import { useEffect, useState } from "react";

const NAV_LINKS = [
  { href: "#hot", label: "今日热瓜" },
  { href: "#picks", label: "深扒精选" },
  { href: "#truth", label: "真相脉络" },
  { href: "#story", label: "编辑部特稿" },
  { href: "#guide", label: "吃瓜指南" },
  { href: "#about", label: "关于我们" },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={
        "fixed inset-x-0 top-0 z-50 transition-colors duration-300 " +
        (solid ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-transparent")
      }
    >
      <nav className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6">
        {/* 品牌 */}
        <h1 className="m-0 flex shrink-0 items-center gap-2 leading-none">
          <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl font-black tracking-wide text-foreground-950 md:text-2xl">
              看吃瓜
            </span>
            <span className="hidden rounded-sm bg-accent-500 px-1.5 py-0.5 text-[10px] font-bold text-background-50 lg:inline-block">
              DEEP DIVE
            </span>
          </a>
        </h1>

        {/* 桌面导航 */}
        <div className="hidden items-center gap-1 md:flex">
          {NAV_LINKS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-2 md:flex">
          <a
            href="#subscribe"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-mail-send-line" aria-hidden="true"></i>
            订阅周报
          </a>
        </div>

        {/* 移动端汉堡 */}
        <button
          type="button"
          aria-label="展开菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
        </button>
      </nav>

      {/* 移动端面板 */}
      {open && (
        <div className="border-t border-background-200 bg-background-50/98 px-4 pb-5 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-base font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              <i className="ri-mail-send-line" aria-hidden="true"></i>
              订阅看吃瓜周报
            </a>
          </div>
        </div>
      )}
    </header>
  );
}